import { Component, OnInit, AfterContentInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { CommonsService } from 'src/app/services/commons.service';
import { NewAggregationService } from 'src/app/services/new-aggregation.service';
import { ModalSummaryComponent } from 'src/app/components/modals/modal-summary/modal-summary.component';
import { CONSTANTS } from '../../../../shared/constants';
import { EntitiesService } from 'src/app/services/entities.service';
import { trigger, style, animate, transition } from '@angular/animations';

declare var $: any;
declare var document;

@Component({
  standalone: false,
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(1500, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class MainComponent implements OnInit, AfterContentInit {

  show = true;
  data: any;
  list = [];
  nameAccount: string;
  code: string;
  token: string;
  country: string;
  scoring: number;
  aviso: string;
  totalValueAccount = 0;
  showProfile: boolean;
  loadingRefresh = false;
  loading = true;

  constructor(private readonly route: Router, private readonly c: CommonsService, private readonly modal: MatDialog,
    private readonly account: NewAggregationService, private ent: EntitiesService) {
    this.showProfile = (sessionStorage.getItem('A_profile') === 'Y_P') ? true : false;
  }

  ngOnInit() {
    this.data = this.getData();
    this.data = (this.data.score) ? this.data : this.data.Scores[0];
    this.aviso = this.data.score.warning;
    this.list = this.data.score.CategoryScore;
    this.scoring = this.data.score.ScoreNumber;
    this.c.firstChargePage('Main', 'Vista principal', 'content');
    this.c.eventsAnalitics('visit screen', 'Resumen financiero', 'Main');
    this.country = sessionStorage.getItem('country') || 'ES';
  }

  ngAfterContentInit() {
    setTimeout(() => {
      $('#autoWidth').lightSlider({
        autoWidth: true,
        loop: false
      });
      document.getElementsByClassName('lSPager')[0].style.display = 'none';
      this.show = false;
      $('#entities').lightSlider({
        autoWidth: true,
        loop: false
      });
      document.getElementsByClassName('lSPager')[0].style.display = 'none';
      this.show = false;
    }, 100);
  }


  getData() {
    let d = sessionStorage.getItem('_k') ? this.c.decrypt(sessionStorage.getItem('_k')) : this.c.getKpi();
    if (d.score) {
      d = (this.c.getKpi() && this.c.getKpi().kpis && this.c.getKpi().kpis.length)
        ? this.c.getKpi() : this.c.decrypt(sessionStorage.getItem('_k'));
    } else {
      d = (this.c.getKpi() && this.c.getKpi().Scores) ? this.c.getKpi() : this.c.decrypt(sessionStorage.getItem('_k'));
    }
    return d;
  }

  getColor(num: number) {
    switch (num) {
      case 10:
      case 9:
      case 8:
      case 7:
        return '#007A5E';
      case 6:
      case 5:
        return '#AD8A00';
      case 4:
      case 3:
        return '#B04626';
      case 2:
      case 1:
      case 0:
        return '#B22B35';
    }
  }

  getExpression() {
    switch (this.scoring) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
        return 'Intenta mantener buenos hábitos para mejorar tu Salud Financiera. ¡Tú puedes conseguirlo!';
      case 5:
      case 6:
        return 'Estás en el buen camino. Mantén buenos hábitos y tu Salud Financiera mejorará.';
      case 7:
      case 8:
        return 'Tu Salud Financiera parece estar en buena forma, ¡Sigue así!';
      case 9:
      case 10:
        return 'Aparentemente disfrutas de una buena Salud Financiera. ¡Lo estás haciendo genial!';
    }
  }

  getLast4Characters(account) {
    return account.slice(account.length - 4, account.length);
  }

  getNameEntity(account: string) {
    this.nameAccount = this.c.getNameEntity(account);
    return this.nameAccount;
  }

  goToCategory(category) {
    let ind;
    this.data.score.CategoryScore.filter((data, i) => {
      if (data.CategoryName === category) {
        ind = i;
        this.c.eventsAnalitics('click', 'Categoría', category);
      }
    });
    sessionStorage.setItem('currentCategory', ind);
    this.route.navigateByUrl('/global-position/summary/detail');
  }

  openModal(): void {
    const modalConfig = new MatDialogConfig();
    modalConfig.width = '90%';
    modalConfig.id = 'modal-info';
    modalConfig.maxWidth = '500px';
    modalConfig.data = this.data.score.CategoryScore;
    this.modal.open(ModalSummaryComponent, modalConfig);
    this.c.eventsAnalitics('click', 'INFO', 'Modal de informacion');
  }

  // addNewAccount() {
  //   sessionStorage.removeItem('refreshEntityCode');
  //   this.account.addNewAccount().subscribe(data => {
  //     if (data.Code === 200) {
  //       this.ent.getTink(sessionStorage.getItem('t')).subscribe(data => window.location.href = data);
  //     } else if (data.Code === 401) {
  //       this.c.openModalSession();
  //     } else {
  //       return;
  //     }
  //   }, error => {
  //     this.c.openModalSession();
  //     this.c.eventsAnalitics('click', 'Añadir nueva cuenta', 'Main');
  //    // this.route.navigateByUrl('/terms');
  //   });
  // }

  addNewAccount() {
    this.route.navigateByUrl('/login');
  }

  getBankLink(d){
    this.token = sessionStorage.getItem('t')
    this.ent.getBankLink(this.token, d, this.country).subscribe(data => window.location.href = data);
  }

  inviteWhatsApp = () => {
    window.open('https://api.whatsapp.com/send?text=' + CONSTANTS.phrasesWhatsApp[0]);
  }

  shareScoringWhatsApp = () => {
    window.open('https://api.whatsapp.com/send?text=Hola! quiero compartir contigo la puntuación de mi salud financiera en Akana. https://www.akana.es/FRONT/%23/scoring?s=' + this.scoring);
  }

  goToLogin = (code, id) => {
    if (this.loading) {
      this.loading = false;
      sessionStorage.setItem('refreshEntityCode', code);
      this.loadingRefresh = true;
      document.getElementById(id).classList.add('r');
      this.ent.getTink(sessionStorage.getItem('t')).subscribe(data => window.location.href = data);
    }
  }
}
